import React from 'react';
import PaymentIFrame from '../../components/payment-iframe';
import './PaymentMethod.scss';
import { useSelector, useDispatch } from 'react-redux';
import { State } from '../../store/interfaces';
import {
  OnlinePaymentStatus,
  actions as registrationActions,
} from '../../store/reducers/registration';
import { PaymentMessage } from '../../models/payment';
import { ContainerLoader } from '../../components/loader';
import { trackPurchase } from '../../utils/analytics';

interface CustomProps {
  gotoPreviousBlock?: () => void;
}

const PaymentMethod: React.SFC<CustomProps> = (props: CustomProps) => {
  const {
    onlinePaymentInfo,
    onlinePaymentStatus,
    summary,
    paymentPlan,
    promoCode,
    referenceNumber,
  } = useSelector((state: State) => state.registration);
  const { user } = useSelector((state: State) => state.authUser);

  const payingAmount =
    summary.totalAmount + summary.totalTax - summary.totalDiscount;

  const dispatch = useDispatch();

  const completePayment = (data: PaymentMessage) => {
    const retryPayment = onlinePaymentStatus === 'failed' ? true : false;
    const validReferenceNumber = referenceNumber ? referenceNumber : '';
    dispatch(
      registrationActions.verifyPayment(data.data, retryPayment, validReferenceNumber, () => {
        trackPurchase(
          payingAmount,
          user ? user._id || '' : '',
          promoCode || '',
          paymentPlan
        );
      })
    );
  };

  if (onlinePaymentStatus === OnlinePaymentStatus.failed) {
    // Registration
    if (props.gotoPreviousBlock) {
      props.gotoPreviousBlock();
    }
  }
  if (
    !onlinePaymentInfo &&
    (!onlinePaymentStatus ||
      onlinePaymentStatus === OnlinePaymentStatus.processing)
  ) {
    return (
      <ContainerLoader height={800} text={'Please wait...'}></ContainerLoader>
    );
  }

  if (onlinePaymentStatus !== OnlinePaymentStatus.processing) {
    const loadingText =
      onlinePaymentStatus === OnlinePaymentStatus.initiated
        ? 'Please wait while we loading payment data..'
        : onlinePaymentStatus === OnlinePaymentStatus.verifying
        ? 'Please wait, we are verifying your payment..'
        : '';
    return <ContainerLoader height={800} text={loadingText}></ContainerLoader>;
  }

  return (
    <div className="PaymentMethod">
      <PaymentIFrame
        className="border-0"
        id="registration-payment"
        url={onlinePaymentInfo.href}
        width="100%"
        height="100%"
        onCompletePayment={completePayment}
      ></PaymentIFrame>
    </div>
  );
};

export default PaymentMethod;
